import { createSelector } from "reselect";

import { getPageContent } from "shared/selectors";

const hasAttachments = createSelector([getPageContent], pageContent => {
  return pageContent?.attachments?.length > 0;
});

export default hasAttachments;
